import React from "react";
import PlanillaPageLayout from "./PlanillaPageLayout";

const RRHHReportes = () => (
  <PlanillaPageLayout
    title="Reportes de RRHH"
    description="Desde aquí se publicarán los reportes y tableros de Recursos Humanos."
  >
    <p className="text-muted mb-0">Esta sección estará disponible en la próxima iteración.</p>
  </PlanillaPageLayout>
);

export default RRHHReportes;
